<wbo-single-select-control [mode]="SelectControlMode.Navigation"
                           [valueField]="valueField"
                           [labelField]="labelField"
                           [attr.id]="elementId"
                           [sourceSearchModel]="model"
                           [data]="data"
                           [getOptionMetaData]="getOptionMetaData"
                           [labelSearchField]="labelSearchField"
                           [label]="label"
                           (onSelect)="onSelect($event)"
                           (onAdd)="onAdd()"
                           (onAction)="onAction($event)"
                           [extendedSearchComponent]="extendedSearchComponent"
                           [extendedSearchComponentParams]="extendedSearchComponentParams"
                           [extendedEditComponent]="extendedEditComponent"
                           [extendedEditComponentParams]="extendedEditComponentParams"
                           [showAddOption]="showAddOption"
                           [actions]="actions">
</wbo-single-select-control>
